import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../../components/common/Footer";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import ProductSection from "./ProductSection";
import ResearchSection from "./ResearchSection";
import MissionSection from "./MissionSection";
import TestimonialSection from "./TestimonialSection";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>
          Utpann Organic Agriculture Solutions | Sustainable Farming & Soil
          Health Restoration
        </title>
        <meta
          name="description"
          content="Utpann promotes organic farming through fermented organic manure, bio-gas production, and natural quality products. Sustainable agriculture solutions for soil health restoration and eco-friendly farming practices."
        />
        <meta
          property="og:title"
          content="Utpann Organic Agriculture Solutions | Sustainable Farming & Soil Health Restoration"
        />
        <meta
          property="og:description"
          content="Utpann promotes organic farming through fermented organic manure, bio-gas production, and natural quality products. Sustainable agriculture solutions for soil health restoration and eco-friendly farming practices."
        />
      </Helmet>

      <main className="overflow-hidden">
        <HeroSection />
        <AboutSection />
        <ProductSection />
        <ResearchSection />
        <MissionSection />
        <TestimonialSection />
        <Footer />
      </main>
    </>
  );
};

export default Home;
